import React from 'react';
import { motion } from 'framer-motion';

const PageTransition = ({ children }) => {
  // Check if children is a main element with Hero and content
  const isMainWithHero = React.Children.count(children) === 1 && 
    children.type === 'main';

  if (isMainWithHero) {
    const mainChildren = React.Children.toArray(children.props.children);
    const heroComponent = mainChildren.find(child => 
      child.type && child.type.name === 'Hero'
    );
    const otherChildren = mainChildren.filter(child => 
      !child.type || child.type.name !== 'Hero'
    );

    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          type: 'tween',
          ease: 'easeInOut',
          duration: 0.3
        }}
        style={{
          width: '100%',
          minHeight: 'auto',
          flex: '1 0 auto'
        }}
      >
        {/* Hero section with its own animation */}
        {heroComponent && (
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            transition={{
              type: 'tween',
              ease: 'easeOut',
              duration: 0.2,
              delay: 0.1
            }}
          >
            {heroComponent}
          </motion.div>
        )}
        
        {/* Page content with separate animation */}
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{
            type: 'tween',
            ease: 'easeOut',
            duration: 0.2,
            delay: 0.2
          }}
        >
          {otherChildren}
        </motion.div>
      </motion.main>
    );
  }

  // Fallback for other content structures
  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -50, opacity: 0 }}
      transition={{
        type: 'tween',
        ease: 'easeInOut',
        duration: 0.4
      }}
      style={{
        width: '100%',
        minHeight: 'auto',
        flex: '1 0 auto'
      }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
